import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { IInvitation } from '../../types/invitation';

interface UserInvitationDetailsProps {
  invitation: IInvitation;
}

const UserInvitationDetails: React.FC<UserInvitationDetailsProps> = ({ invitation }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.info}>
        User has automatically received initial Onboarding Email. Would you like to send Another?
      </Text>
      <Text style={styles.label}>
        <strong>Tenant Name:</strong> {invitation.tenant_name}
      </Text>
      <Text style={styles.label}>
        <strong>Email:</strong> {invitation.email}
      </Text>
      <Text style={styles.label}>
        <strong>User ID:</strong> {invitation.user_id}
      </Text>
      <Text style={styles.label}>
        <strong>Invitation ID:</strong> {invitation.reservation_id}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 10,
    backgroundColor: '#fff'
  },
  info: {
    fontSize: 16,
    marginBottom: 20
  },
  label: {
    fontSize: 14
  }
});

export default UserInvitationDetails;
